export default "__VITE_ASSET__e961390c__"